import styled from 'styled-components';
import { RhRawButton } from './RhRawButton';
import { colors, Regular } from './Styles';

export const ChurchBadge = styled.span`
  color: #fff;
  background-color: #17a2b8;
  padding-right: 0.6em;
  padding-left: 0.6em;
  padding-top: 0.2em;
  margin: 5px;
  padding-bottom: 0.2em;
  border-radius: 10rem;
`;

export const StudyVisibilityWrap = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin-right: 12px;
  padding: 6px 10px;
  border-radius: 999px;
  background: ${colors.background};
  border: 1px solid ${colors.faintGrey};
`;

export const ToggleLabel = styled.span`
  font-size: 13px;
  font-weight: 800;
  color: ${colors.subtle};
  user-select: none;
`;

export const InfoButton = styled.button`
  all: unset;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  border-radius: 9px;
  cursor: help;

  &:focus-visible {
    outline: none;
    box-shadow: 0 0 0 3px rgba(18, 116, 189, 0.22);
  }
`;

export const TooltipText = styled(Regular)`
  max-width: 280px;
  line-height: 18px;
`;

export const Toggle = styled.button<{ pressed: boolean }>`
  width: 44px;
  height: 26px;
  border-radius: 999px;
  border: 0;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  background: none !important;
  background-image: none !important;
  background-color: ${({ pressed }) => (pressed ? colors.primary : colors.lightGrey)} !important;
  display: inline-flex;
  align-items: center;
  padding: 3px;
  cursor: pointer;
  transition: background-color 160ms ease, box-shadow 160ms ease, opacity 160ms ease;
  box-shadow: inset 0 0 0 1px rgba(0, 0, 0, 0.1), 0 1px 2px rgba(0, 0, 0, 0.06);

  &:hover:not(:disabled) {
    box-shadow: inset 0 0 0 1px rgba(0, 0, 0, 0.14), 0 2px 6px rgba(0, 0, 0, 0.1);
  }

  &:focus-visible {
    outline: none;
    box-shadow: 0 0 0 3px rgba(18, 116, 189, 0.22), inset 0 0 0 1px rgba(0, 0, 0, 0.1), 0 1px 2px rgba(0, 0, 0, 0.06);
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

export const Knob = styled.span<{ pressed: boolean }>`
  width: 20px;
  height: 20px;
  border-radius: 999px;
  background: #fff;
  border: 1px solid rgba(0, 0, 0, 0.06);
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.1), 0 1px 2px rgba(0, 0, 0, 0.12);
  transform: ${({ pressed }) => (pressed ? 'translateX(18px)' : 'translateX(0)')};
  transition: transform 160ms ease;
`;

export const Container = styled.div`
  height: 80px;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 16px;
  border-bottom: 1px solid #e2e7ea;
`;

export const Flexed = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
`;

export const Border = styled.div`
  margin-left: 30px;
  display: flex;
  align-items: center;
  padding: 8px;

  & > :not(:last-child) {
    margin-right: 18px;
  }
`;

export const Logo = styled.img`
  width: 200px;
  height: auto;
  object-fit: contain;
  margin-left: -10px;
`;

export const Image = styled.img`
  height: 48px;
  width: 48px;
  border-radius: 24px;
`;

export const NotificationDiv = styled(RhRawButton)`
  position: relative;
`;

export const Tick = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  transform: translate(50%, -50%);
  font-weight: bold;
  font-size: 10px;
  letter-spacing: 0.035em;
  color: #ffffff;
  background-color: ${colors.primary};
  width: 16px;
  height: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
`;
